import { z } from 'zod';
import { HistoryReportFilterI } from 'types';

export const ageRangeOptions = {
  0: [18, 29],
  1: [30, 50],
  2: [51, 100],
};

/**
 * Esquema de validación para los filtros del reporte de historial de empleados.
 * Incluye campos para búsqueda por nombre, fechas, terminal, departamento,
 * puesto, género y rango de edad.
 */
export const historyReportFilterSchema = z.object({
  search: z.string().optional(),
  gender: z.string().optional(),
  jobTitleId: z.string().optional(),
  terminalId: z.string().optional(),
  departmentId: z.string().optional(),
  entryDateStart: z.string().optional(),
  entryDateEnd: z.string().optional(),
  ageMin: z.number().optional(),
  ageMax: z.number().optional(),
  ageRange: z.number().optional(), // Campo interno para UI, no se envía al backend
  page: z.number().optional(),
  limit: z.number().optional(),
});

/**
 * Valores predeterminados para los filtros del reporte de historial de empleados.
 */
export const defaultValue: HistoryReportFilterI = {
  search: '',
  gender: undefined,
  jobTitleId: undefined,
  terminalId: undefined,
  departmentId: undefined,
  entryDateStart: undefined,
  entryDateEnd: undefined,
  ageMin: undefined,
  ageMax: undefined,
  ageRange: undefined,
  page: 1,
  limit: 10,
};
